import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Loading from "components/Loading";
import Layout from "pages/Layout";
import Auth from "pages/Auth";
import NotFound from "pages/NotFound";
import Unauthorized from "pages/Unauthorized";
import { RequireAuth } from "services/auth";

const CorporateActionNotice = lazy(() => import("pages/CorporateActionNotice"));
const MandatoryNoticeDetail = lazy(() => import("pages/MandatoryNoticeDetail"));
const VoluntaryNoticeDetail = lazy(() => import("pages/VoluntaryNoticeDetail"));

export const RouteElement = ({ element }) => {
  return <Suspense fallback={<Loading />}>{element}</Suspense>;
};

export const RouteElementAuth = ({ element }) => {
  return (
    <RequireAuth>
      <RouteElement element={element} />
    </RequireAuth>
  );
};

export default function RouteApp() {
  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <Routes>
        <Route element={<Auth />} path="/auth/:key" />
        <Route element={<Layout />} path="/">
          <Route
            index
            element={<RouteElementAuth element={<CorporateActionNotice />} />}
          />
          <Route
            element={<RouteElementAuth element={<MandatoryNoticeDetail />} />}
            path="/mandatorydetail/:id"
          />
          <Route
            element={<RouteElementAuth element={<VoluntaryNoticeDetail />} />}
            path="/voluntarydetail/:id"
          />

          <Route element={<Unauthorized />} path="/unauthorized" />
          <Route element={<NotFound />} path="*" />
        </Route>
      </Routes>
    </Router>
  );
}
